















































import { Component, Vue } from 'vue-property-decorator'
import Navigation from '@/components/layout/Navigation.vue'
import { vxm } from '@/store/'
import FooterMain from '@/components/layout/Footer.vue'
import Corona from '@/components/modals/Corona.vue'

@Component({
  components: {
    FooterMain,
    Navigation,
    Corona
  }
})
export default class App extends Vue {
  created() {
    vxm.core.setLanguage()
  }
}
